import { render, staticRenderFns } from "./form-choice.vue?vue&type=template&id=4e500c48"
import script from "./form-choice.vue?vue&type=script&lang=js"
export * from "./form-choice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports